// extracted by css-extract-rspack-plugin
export default {"container":"src-domain-pages-logical-device-screen-share-page-logicalDeviceScreenSharePage-module__container-EUiNAZ","containerScreenShare":"src-domain-pages-logical-device-screen-share-page-logicalDeviceScreenSharePage-module__containerScreenShare-Gsg7Po","containerControl":"src-domain-pages-logical-device-screen-share-page-logicalDeviceScreenSharePage-module__containerControl-Jrxs8o"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-domain-pages-logical-device-screen-share-page-logicalDeviceScreenSharePage-module__container-EUiNAZ\",\"containerScreenShare\":\"src-domain-pages-logical-device-screen-share-page-logicalDeviceScreenSharePage-module__containerScreenShare-Gsg7Po\",\"containerControl\":\"src-domain-pages-logical-device-screen-share-page-logicalDeviceScreenSharePage-module__containerControl-Jrxs8o\"}";
        // 1793705032543
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  